import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useStaffUnitDetails = (staffId: number) => {
  return trpc.unit.getStaffUnitDetails.useQuery(
    { staffId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!staffId,
    },
  );
};
